import { Button } from 'antd';
import React, {useEffect, useState} from 'react';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { SlClose } from 'react-icons/sl';
import ReactPlayer from 'react-player';
import { isAuthenticated, isVideo } from '../../../utilities';

function ModeratorFullPageAd({ advData, closeAd, updateAdClickToSocket, updateAdViewToSocket }) {

    const [count, setCount] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
            setCount(prevCount => prevCount > 0 ? prevCount - 1 : prevCount);
        }, 1000);
    
        return () => {
            clearInterval(interval)
        }
    }, [])
    

    useEffect(() => {
        let timeOutId = null;
        if (advData && advData.adId) {
          timeOutId = setTimeout(() => {
            handleAdvClickOrView();
          }, 1000);
        }
        return () => {
          if (timeOutId) {
            clearTimeout(timeOutId);
          }
        };
    }, [advData]);

    const handleAdvClickOrView = (isClick, ev) => {
      if (ev) {
        ev.stopPropagation();
      }
      if (!advData || !advData.adId) {
        return;
      }
      let payload = {
        adId: advData.adId,
        moderatorSectionAdId: advData.moderatorSectionAdId,
        questionAdId: advData.questionAdId,
        accessToken: isAuthenticated()
      };
      isClick ? updateAdClickToSocket(payload) : updateAdViewToSocket(payload)
      if (isClick && advData.sourceUrl) {
        document.activeElement.blur();
        window.open(advData.sourceUrl, "_blank");
      }
    };

    return advData ? 
        <div className='fixed bg-white-100 font-color-1 top-0 left-0' style={{width: '100vw', height: '100vh', zIndex: '10'}}>
            {isVideo(advData.contentUrl) ? (
                <div>
                    <Button
                        type="primary"
                        icon={<MdOutlineOpenInNew className="mr-8" />}
                        size="small"
                        className="flex items-center bg-white-80 font-color-1 border-white-80"
                        onClick={(e) => handleAdvClickOrView(true, e)}
                        style={{ float: "right", marginBottom: "-80px", marginTop: "10px", marginRight: "10px", zIndex: "100" }}
                    >
                        Learn More
                    </Button>
                    <ReactPlayer playing={true} url={advData.contentUrl} config={{ file: { attributes: { controlsList: "nodownload" } } }} width="100%" height="100%" loop={true} playsinline={true} muted={true} controls={true} />
                </div>
            ) : (
                <img onClick={() => handleAdvClickOrView(true)} src={advData.contentUrl} width={'100%'} height={'100%'} style={{objectFit: 'contain'}} alt={advData.name} />
            )}
            <Button type='primary' disabled={count > 0} onClick={closeAd} className="absolute flex items-center width-fit-content bottom-15 right-0 left-0 font-bold-600" style={{ margin: 'auto' }}>
                Close | {count > 0 ? count : <SlClose className='font-size-14 ml-5' />}
            </Button>
        </div> : ''
}

export default ModeratorFullPageAd;